import { render } from "./ViewTemplate.vue?vue&type=template&id=41e852c2"
import script from "./ViewTemplate.vue?vue&type=script&lang=js"
export * from "./ViewTemplate.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__